import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { CSSProperties } from 'react';

/** shadcn 慣例：合併 class，後者覆蓋前者的同類 Tailwind 工具類。 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** 動態層的出場順序：對應 motion.css 的 --i 變數（每格 60ms）。 */
export const order = (i: number) => ({ '--i': i }) as CSSProperties;
